<template>
    <!-- 优惠券/免息券楼层组件 -->
    <div :class="{'sumOfReservationGuideBtn_height_Bottom':serviceId}"
        :style="backgroundStyle(item)">
        <!-- 登录组件 -->
        <login-in v-if="isAlonePage"
            :loginType="loginType"
            :isLoginFlag="isLoginFlag"
            :activityUrl="activityUrl">
        </login-in>
        <div class="coupons">
            <!--1*1样式-->
            <div v-if="item.imgStyle=='1'"
                class="coupon_card1">
                <div v-for="(cItem, cIndex) in item.couponMainVOList"
                    :key="cItem.id"
                    class="coupon_item"
                    :style="getCardStyle(cItem.useStatus)">
                    <!-- 优惠券角标-->
                    <div v-if="item.pageType=='coupon' && item.couponCornerPic"
                        class="coupon-corner">
                        <img class="coupon-corner-img"
                            :src="item.couponCornerPic">
                    </div>
                    <!-- 免息券角标 -->
                    <div v-if="item.pageType=='offinterest' && item.offInterestCornerPic"
                        class="coupon-corner">
                        <img class="coupon-corner-img"
                            :src="item.offInterestCornerPic">
                    </div>
                    <div class="item_content">
                        <!-- 优惠券和免息券展示图片 -->
                        <div class="price-contain">
                            <img class="main-img"
                                :src="cItem.mainImg">
                        </div>
                        <!-- 展示条件：活动开始时间晚于当前时间并且活动状态为07未到领取时间 -->
                        <div v-if="cItem.recieveTime > 0 && cItem.useStatus === '07'"
                            class="count_down">
                            <!-- 未到领取时间，显示倒计时 -->
                            <themaicCountDown :countColor="countColor"
                                :blockColor="blockColor"
                                :blockBackgroundColor="blockBackgroundColor"
                                :time="cItem.recieveTime"
                                @timeDownFinished="timeDownFinished(cIndex)"></themaicCountDown>
                        </div>
                        <div class="item_subattr">
                            <!-- 优惠券、免券券名称和领取时间 -->
                            <div class="title_text">
                                <div class="title ellipsis-text">{{ cItem.couponName }}</div>
                                <div class="use_date ellipsis-text">{{ formatTime(cItem.pickupStartTime) }} ~ {{ formatTime(cItem.pickupEndTime) }}</div>
                            </div>
                            <!-- 剩余数量和文字颜色配置 -->
                            <div class="balance_count"
                                :style="{'color': item.wordsColor}">
                                <!-- 已领完和不可领取不展示剩余数量  -->
                                <span
                                    v-if="!(['06', '08', '11', '12'].includes(cItem.useStatus) ) && item.showRemainingAmountWay === '1' && cItem.balanceAmount > 99999">剩余99999+</span>
                                <span
                                    v-if="!(['06', '08', '11', '12'].includes(cItem.useStatus)) && item.showRemainingAmountWay === '1' && cItem.balanceAmount <= 99999 && cItem.balanceAmount > 0">剩余：{{ cItem.balanceAmount }}</span>
                                <span
                                    v-if="!(['06', '08', '11', '12'].includes(cItem.useStatus)) && item.showRemainingAmountWay === '1' && cItem.balanceAmount === 0">剩余：0</span>
                                <span
                                    v-if="!(['06', '08', '11', '12'].includes(cItem.useStatus)) && item.showRemainingAmountWay === '2' && cItem.balanceAmount === 0">已领完</span>
                                <span
                                    v-if="!(['06', '08', '11', '12'].includes(cItem.useStatus)) && item.showRemainingAmountWay === '2' && cItem.balanceAmount >= 1 && cItem.balanceAmount <= 100">数量较少</span>
                                <span
                                    v-if="!(['06', '08', '11', '12'].includes(cItem.useStatus)) && item.showRemainingAmountWay === '2' && cItem.balanceAmount > 100">数量充裕</span>
                            </div>
                            <div class="opt_btn">
                                <div class="user-vip"
                                    v-if="item.pageType=='coupon' && cItem.restrictType !== '0'">{{cItem.restrictTypeName}}</div>
                                <!-- 立即领取按钮 -->
                                <div v-if="cItem.useStatus === '01'">
                                    <div v-if="cItem.isShow"
                                        class="get-btn"
                                        @click="handleReceivecoupon(cItem,item,cIndex)">
                                        <img class="get-btn-img"
                                            :src="item.receiveButtonImgUrl">
                                    </div>
                                    <div v-else
                                        class="get-btn">
                                        <img class="get-btn-img"
                                            :src="item.notReceiveButtonImgUrl">
                                    </div>
                                </div>
                                <!-- 不可领取按钮 -->
                                <div v-if="['07', '09', '1502'].includes(cItem.useStatus)">
                                    <div class="get-btn"
                                        @click="handleNotStart(cItem)">
                                        <img class="get-btn-img"
                                            :src="item.notReceiveButtonImgUrl">
                                    </div>
                                </div>
                                <!-- 去使用按钮 -->
                                <div v-if="cItem.useStatus === '02'">
                                    <div class="get-btn"
                                        @click="backXcx(cItem, item.pageType)">
                                        <img class="get-btn-img"
                                            :src="item.exchangeButtonImgUrl">
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- 已领完状态角标 -->
                        <div v-if="cItem.useStatus === '11'"
                            class="has-received">
                            <img class="has-received-img"
                                src="../../../../../static/runtime/images/magic/received.png">
                        </div>
                        <!-- 已使用状态角标-->
                        <div v-if="cItem.useStatus === '05'"
                            class="has-received">
                            <img class="has-received-img"
                                src="../../../../../static/runtime/images/magic/used.png">
                        </div>
                        <!-- 已过期状态角标-->
                        <div v-if="cItem.useStatus === '06'"
                            class="has-received">
                            <img class="has-received-img"
                                src="../../../../../static/runtime/images/magic/expired.png">
                        </div>
                        <!-- 超过活动领取时间状态角标 -->
                        <div v-if="cItem.useStatus === '08'"
                            class="has-received">
                            <img class="has-received-img"
                                src="../../../../../static/runtime/images/magic/exceedReceiveTime.png">
                        </div>
                        <!-- 已下架状态角标-->
                        <div v-if="cItem.useStatus === '12'"
                            class="has-received">
                            <img class="has-received-img"
                                src="../../../../../static/runtime/images/magic/hasBeenRemoved.png">
                        </div>
                    </div>
                </div>
            </div>
            <!--1*2样式，目前PC已没有这种-->
            <div v-if="item.imgStyle=='2'"
                class="coupons_list12">
                <div v-for="(element, cIndex) in item.couponMainVOList"
                    :key="element.id"
                    class="coupons_list12_item"
                    :style="getCardStyle(element.useStatus)">
                    <div class="coupons_list12_item_type">{{ element.skuScope=='01'?'全场商品可用':'指定商品可用' }}</div>
                    <div class="coupons_list12_item_content">
                        <div class="coupons_list12_item_head">
                            <div v-if="item.pageType === 'coupon'"
                                class="coupons_list12_item_content_amount"><span style="font-size: 12px;">￥</span>{{ element.couponValue }}</div>
                            <div v-if="item.pageType === 'coupon'"
                                class="coupons_list12_item_content_text">满￥{{ element.satisfyMoney }}可用</div>
                            <img v-if="item.pageType === 'offinterest'"
                                class="offinterest_img"
                                src="../../../../../static/runtime/images/magic/interestFree.png">
                            <!-- 样式占位 -->
                            <div class="coupon_left"
                                :style="item.filePath&&item.backgroundType=='image' ? 'background: transparent;' :'background:'+item.backgroundContent+';'">
                            </div>
                            <div class="coupon_right"
                                :style="item.filePath&&item.backgroundType=='image' ? 'background: transparent;' :'background:'+item.backgroundContent+';'">
                            </div>
                        </div>
                        <div style="position: relative;">
                            <div class="coupons_list12_item_content_name"
                                style=" -webkit-box-orient: vertical; ">{{ element.couponName }}</div>
                            <van-button v-if="['01', '02'].includes(element.useStatus)"
                                class="card1_btn"
                                :loading="element.isLoading"
                                @click="handleReceivecoupon(element,item, cIndex)">立即领取</van-button>
                            <van-button v-if="element.useStatus=='07'"
                                class="card1_btn goUse"
                                @click="handleNotStart(element)">待开始</van-button>
                            <van-button v-if="['06','08', '11', '12'].includes(element.useStatus)"
                                class="card1_btn hasBeenUsed"
                                disabled>已领完</van-button>
                            <van-button v-if="element.useStatus=='05'"
                                class="card1_btn hasBeenUsed"
                                disabled>已使用</van-button>
                        </div>
                    </div>
                    <div v-if="element.useStatus=='02'"
                        class="coupon_mask">
                        <van-button class="card1_btn coupon_mask_btn">
                            <div class="card1_btn_text">去使用
                                <van-icon name="arrow" />
                            </div>
                            <div v-if="miniprogramFlag || loginType == 'Alipay'"
                                style="position: absolute; top: 0; width: 74px; height: 30px; z-index: 99999;"
                                @click="backXcx(element, item.pageType)"></div>
                        </van-button>
                    </div>
                </div>
            </div>
        </div>
        <!--领取优惠券的时候验证身份弹框 -->
        <identityVerifyDialog ref="identityComponent"
            :isShowIdentityDialog.sync="isShowIdentityDialog"
            :verifyTitle="couponVerifyTitle"
            :activityUrl="activityUrl"
            :identityTypeList="identityTypeList"
            :isShowCheckBtn="isShowCheckBtn"
            :activityCode="activityCode"
            :clickListId="elementParentObjId"
            :clickIndex="clickIndex"
            :pageSource="'thematicActivity'"
            :isClickNextPage="isClickNextPage"
            :loginType="loginType"
            :handleReceivecoupon="handleReceivecoupon"
            :elementParentObj="elementParentObj"
            :clickElementObj="clickElementObj"
            :checkChannel="1"
            :activityType="activityType"
            :guideUserId="guideUserId"
            :storeCode="storeCode"
            :checkResultList="checkResultList"
            :activityName="activityName"></identityVerifyDialog>
    </div>

</template>

<script>
import themaicCountDown from '../themaicComponent/themaic-count-down.vue';
import { Toast, Dialog } from 'vant';
import utils, { AllLoginTypeHandler } from '../../../../utils/comUtils.js';
import { queryNeedNotifyAwardInfo } from '../../../../commons/commonJudgeIsNeedNotify.js';
import wx from 'weixin-js-sdk';
import { PMLinkType, useStatus, CustomerGroup, LoginType, SkuScopeType, JumpType, CouponType } from '../../../../commons/commonVariables';
import { jumpToPointsMall, pointsMallLinkJudge, couponDataHandler, jumpToNext } from '../common-methods/utils';
import { config } from '../../../../api/config';
import identityVerifyDialog from '../dynamicAttr/identityVerifyDialog.vue';
import loginIn from '../dynamicAttr/modal/login-in.vue';

export default {
  components: {
    themaicCountDown,
    identityVerifyDialog,
    loginIn,
  },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    activityObj: {
      type: Object,
      default: () => {},
    },
    serviceId: {
      type: String,
      default: '',
    },
    miniprogramFlag: {
      type: Boolean,
      default: true,
    },
    activityInfo: {
      type: Array,
      default: () => [],
    },
    enableMessageNotifications: {
      type: String,
      default: '',
    },
    mobileVerification: {
      type: String,
      default: '',
    },
    smallElementCoupon: {
      type: Object,
      default: () => {},
    },
    smallIndexCoupon: {
      type: Number,
      default: null,
    },
    bigItemCoupon: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    detail: {
      handler(val) {
        if (val) {
          this.item = val;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      shareType: '',
      pageId: '',
      pageType: '',
      backgroundType: '',
      userUnionid: '',
      alipayUserId: '',
      countColor: '#FFFFFF',
      blockColor: '#000',
      blockBackgroundColor: '#FFFFFF',
      item: {},
      awardObj: {},
      goodsIndex: 0,
      userBase: {},
      isReceived: false,
      drawType: 'initDraw',
      loginType: '',
      isLoginFlag: false, // 默认没有登录
      userInfoList: [],
      codeShow: false,
      usedFlag: '',
      adminRegions: {}, //首页行政区域ID对象，入参获取奖品的时候接口
      envVersion: config.env === 'pro' ? 'release' : 'trial', // 拉起小程序的版本
      isShowIdentityDialog: false, //是否展示优惠券的身份验证弹框（教师 医护 学生 三种身份匹配不成功才弹该提示框）
      couponVerifyTitle: '', //展示优惠券的身份验证弹框的内容
      mobileVerificationRouter: '', //pc配置为图片而非背景时，h5点击图片做编程式跳转传过来的mobileVerification 值为新老用户
      identityTypeList: [], //多方认证返回券身份list
      isShowCheckBtn: true, //是否展示去验证按钮
      clickIndex: null, //当前选中券的index
      elementParentObjId: '', //当前选中券的父对象的id
      clickElementObj: {}, //当前选中的券对象
      elementParentObj: {}, //当前选中券的父对象
      isClickNextPage: 'false', //是否点击了下级页面
      isAlonePage: false, // 是否为独立的页面
      activityCode: '', // 活动编码
      isFirst: true, //防抖，执行一次后不再执行
      activityType: '',
      guideUserId: '',
      storeCode: '',
      activityName: '',
      checkResultList: [],
    };
  },
  created() {
    if (this.$route.query.pageId && this.$route.query.activityCode) {
      this.isAlonePage = true;
      this.pageType = this.$route.query.pageType;
      this.activityCode = this.$route.query.activityCode;
      this.backgroundType = this.$route.query.backgroundType;
      this.serviceId = this.$route.query.serviceId;
      this.miniprogramFlag = this.$route.query.miniprogramFlag === 'true';
      this.pageId = this.$route.query.pageId;
      this.mobileVerificationRouter = this.$route.query.mobileVerification;
      this.activityType = this.$route.query.ay;
      this.guideUserId = this.$route.query.GUID;
      this.storeCode = this.$route.query.SC;
      this.activityName = this.$route.query.activityName;
      this.isClickNextPage = 'true';
      // 优惠券/免息券
      if (this.pageType === 'offinterest') {
        document.title = '免息券领取列表';
      } else if (this.pageType === 'coupon') {
        document.title = '优惠券领取列表';
      }

      this.userUnionid = sessionStorage.getItem('userUnionid') || '';
      this.alipayUserId = sessionStorage.getItem('alipayUserId') || '';
      this.handleListQuery();
    } else {
      this.isAlonePage = false;
    }
    // 初始化用户信息
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
    this.userBase = Object.assign({}, userInfo);
    this.loginType = sessionStorage.getItem('loginType') || '';
    this.activityCode = (this.$route.query && this.$route.query.activityCode) || '';
    // 组装当前地址
    this.activityUrl = location.origin + '/hd/hdmain?activityCode=' + this.activityCode;
    if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
      this.activityUrl =
        this.activityUrl + '&ay=' + eventTrackingData.activityType + '&GUID=' + eventTrackingData.guideUserId + '&SC=' + eventTrackingData.storeCode;
    }
    this.isLoginFlag = sessionStorage.getItem('isLoginFlag') === 'true';
    this.adminRegions = JSON.parse(sessionStorage.getItem('adminRegions')) || {};
    // 学生 医护 教师验证完成后重新调取优惠券接口 没有点击进入过下级页面则小程序验证完身份后回到h5走这里
    const isFirst = sessionStorage.getItem('isFirst') || 'true';
    // 缓存中的isFirst为了解决子页面回到父页面不执行下面逻辑 this.isFirst 为了解决在子页面重新执行的问题
    if (this.smallElementCoupon && this.smallElementCoupon.id && this.bigItemCoupon && this.bigItemCoupon.id && this.isFirst && isFirst === 'true') {
      sessionStorage.setItem('isFirst', 'false');
      this.handleReceivecoupon(this.smallElementCoupon, this.bigItemCoupon, Number(this.smallIndexCoupon));
    }
  },
  methods: {
    getCardStyle(status) {
      const style = {};
      // 透明度修改
      if ([useStatus.exceedRecTime].includes(status)) {
        style.opacity = 0.7;
      } else {
        style.opacity = 1;
      }
      return style;
    },
    backgroundStyle(item) {
      const style = {};
      if (!item) {
        return style;
      }
      if (this.backgroundType === 'image') {
        style.backgroundColor = '#f8f8f8';
        style.height = '100vh';
      } else {
        if (item.filePath && item.backgroundType === 'image') {
          style.background = `url('+ ${item.filePath}+') no-repeat`;
        } else {
          style.backgroundColor = item.backgroundContent;
        }
      }
      return style;
    },
    handleListQuery() {
      const loginType = this.loginType === LoginType.Wechat ? 'wxapp' : this.loginType === LoginType.Alipay ? 'alipaymini' : '';
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/projectActivity/queryActivityProject',
        //如果为空，就传空参数，登陆类型为微信登陆但没有登陆时，unionId需要传空字符
        notFilterNull: true,
        params: {
          activityCode: this.activityCode,
          unionId: this.userUnionid,
          alipayUserId: this.alipayUserId,
          loginType: loginType,
        },
        success: (r) => {
          let { code, result } = r;
          if (code === 200 && result) {
            result.loginType = AllLoginTypeHandler(result.loginType);
            const { activityPageList = [], enableMessageNotifications, loginType } = result;
            this.loginType = loginType;
            this.enableMessageNotifications = enableMessageNotifications;
            activityPageList.forEach((ii, index) => {
              if (ii.pageType === this.pageType && ii.id === this.pageId) {
                this.item = activityPageList[index];
              }
            });
            this.item = Object.assign(this.item, couponDataHandler(result, this.item));
            this.item.couponMainVOList.forEach((el) => {
              this.showClaimNowButton(el);
            });
            // 点击进入过下级页面则小程序验证完身份后回到h5走这里,执行完一次之后不再执行
            const isFirstRouter = sessionStorage.getItem('isFirstRouter') || 'true';
            if (sessionStorage.getItem('isClickNextPage') === 'true' && this.isFirst && isFirstRouter === 'true') {
              const index = sessionStorage.getItem('clickIndex');
              sessionStorage.setItem('isFirstRouter', 'false');
              this.handleReceivecoupon(this.item.couponMainVOList[index], this.item, Number(index));
            }
          }
        },
      });
    },
    showClaimNowButton(el) {
      const mobileVerification = this.mobileVerification || this.mobileVerificationRouter;
      // 为新老用户，则判断身份是否符合，符合则显示立即领取，不符合则显示不可领取
      el.isShow = true;
      if ([CustomerGroup.newOldUser].includes(el.restrictType) && el.userAuthenticationValue !== mobileVerification) {
        el.isShow = false;
      }
    },
    handleActivityInfo(val) {
      let arr = [];
      //优惠券
      if (val.pageType === 'coupon' && val.activityPageRewardSettingList) {
        arr = arr.concat(val.activityPageRewardSettingList);
      }
      arr = arr.map((item) => ({
        exchangeGoodsType: item.goodsType, //0:虚拟,1:实物,2:优惠券,3:积分,4:代金券,5:赠品券
        collectionType: item.collectionType, //领取类型(1:邮寄(实物)/线上兑换(虚拟);2:到店自提(实物)/线下核销(虚拟);3:线下核销发串码(虚拟));4:免单抽奖
        businessId: item.activityCode, //普通大转盘传recordId、定时盲盒和定时新盲盒传activityCode、专题传activityCode、签到传bigwheelRewardRecodeId
        businessType: '7', //业务类型 12.签到  7.专题活动 9.大转盘
        goodsId: item.goodsId,
      }));
      return arr;
    },
    /**
     * @param {Object} element: 当前优惠券对象
     * 07: 未到领取时间
     * 09: 未到使用时间
     * 1502: 身份认证失败
     */
    handleNotStart(element) {
      if (element.useStatus === '07') {
        Toast({
          type: 'html',
          message: `<div style='text-align:center;'>领取失败：未到领取时间，<br>请 ${element.startReceiveDate} 后领取</div>`,
        });
      }
    },
    // 优惠券和代金券时间样式调整
    formatTime(time) {
      if (time) {
        return time.slice(0, 10).replace(/-/g, '/');
      }
      return '';
    },
    /**
     * 领取优惠券
     * @param {Object} element: 当前优惠券对象
     */
    handleReceivecoupon(element, elementParentObj, index) {
      if (!this.isLoginFlag) {
        this.$utils.tips.message('warning', '登录后参与活动哦！');
        return;
      }
      if (elementParentObj.pageType === 'coupon' && element.restrictType === CustomerGroup.multimodalVerification) {
        this.identityTypeList = element.userAuthenticationValue && element.userAuthenticationValue.split(','); //去验证身份时的入参
      }
      if (element.isLoading) return;
      element.isLoading = true;
      const loginType = this.loginType === LoginType.Wechat ? 'wxapp' : this.loginType === LoginType.Alipay ? 'alipaymini' : '';
      const params = {
        activityId: elementParentObj.activityId,
        activityCode: elementParentObj.activityCode,
        activityPageId: elementParentObj.id,
        groupCode: element.groupCode,
        nickName: this.userBase.nickName || '',
        userHeadPortraitUrl: this.userBase.headimgurl,
        awardType: elementParentObj.pageType,
        userRewardRegion: this.adminRegions,
        loginType: loginType,
      };
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/projectActivity/activityProjectReceiveAward',
        params,
        success: (res) => {
          // setTimeout(() => {
          element.isLoading = false;
          // }, 5000);
          if (res.code == 200) {
            if (!this.activityPausedHandler(res)) {
              return;
            }
            Toast('领取成功');
            // 领取成功返回优惠券编码
            element.couponCode = res.result || '';
            if (elementParentObj.pageType === 'coupon') {
              setTimeout(() => {
                if (this.loginType === 'wechat' && this.enableMessageNotifications === '1') {
                  const params = this.handleActivityInfo(elementParentObj);
                  queryNeedNotifyAwardInfo(params, this);
                }
              }, 1000);
              this.handleCouponThematicActivityProcess(element);
            } else {
              this.handleClickFloorProcess('offinterest');
            }
            // 点击立即领取，如果配置的有跳转链接，则跳转到指定链接，否则刷新列表变成已使用，走原有跳转逻辑
            if (element.jumpUrl) {
              this.goHihonorUrl(element.jumpUrl);
            }
          } else {
            this.receiveFailedHandler(res, index, element, elementParentObj);
          }
          this.isFirst = false;
          if (this.backgroundType === 'image') {
            this.handleListQuery();
          } else {
            this.$emit('initData');
          }
        },
        failure: (err) => {
          this.isFirst = false;
          setTimeout(() => {
            element.isLoading = false;
          }, 5000);
          Toast('活动过于火爆，请稍后再试');
          if (this.backgroundType === 'image') {
            this.handleListQuery();
          } else {
            this.$emit('initData');
          }
        },
      });
    },
    // 活动暂停处理
    activityPausedHandler(res) {
      if (res.result === 'ACTIVITY_IS_PAUSED') {
        this.$emit('initData');
        return false;
      } else {
        return true;
      }
    },
    // 领取券失败处理
    receiveFailedHandler(r, index, element, elementParentObj) {
      const msg = r.message ? r.message : '领取失败';
      // 权益品已过期，弹窗提示并修改状态为超过使用时间
      if (r.code === 501) {
        Dialog.alert({
          message: msg,
        }).then(() => {
          // 重新调接口
          if (this.$route.query.pageId) {
            this.handleListQuery();
          } else {
            this.$emit('initData');
          }
        });
      } else {
        if (r.code === 1501) {
          this.isShowIdentityDialog = true;
          this.couponVerifyTitle = msg;
          this.isShowCheckBtn = true;
          this.checkResultList = (r.result && r.result.resultList) || [];
          if (elementParentObj.pageType === 'coupon') {
            if (element.restrictType === CustomerGroup.multimodalVerification) {
              this.clickIndex = index;
              this.elementParentObjId = elementParentObj.id;
              this.clickElementObj = element;
              this.elementParentObj = elementParentObj;
            }
          }
        } else if (r.code === 1502) {
          this.isShowIdentityDialog = true;
          this.couponVerifyTitle = msg;
          this.isShowCheckBtn = false;
        } else {
          Toast(msg);
        }
      }
    },

    // 埋码事件：点击(专题页)优惠券楼层
    handleCouponThematicActivityProcess(element) {
      const params = {
        actionCode: 400060006,
        actionName: '优惠券楼层',
        content: {
          title: '优惠券楼层',
          channel: this.loginType == 'none' ? '' : this.loginType == 'wechat' ? '微信' : '支付宝',
          shareType: this.shareType == 'undefined' ? '' : this.shareType,
          couponGroup: element.groupCode,
          couponCode: element.couponCode,
          activityCode: this.activityCode,
        },
      };
      const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
      if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
        params.content.activityName = eventTrackingData.activityName;
        params.content.activityType = eventTrackingData.activityType;
        params.content.guideUserId = eventTrackingData.guideUserId;
        params.content.channelCode = eventTrackingData.storeCode;
      } else if (this.storeCode && this.guideUserId) {
        params.content.activityName = this.activityName;
        params.content.activityType = this.activityType;
        params.content.guideUserId = this.guideUserId;
        params.content.channelCode = this.storeCode;
      }
      utils.handleBatchReport(this, params);
    },
    // 埋码时间：领取权益品楼层、代金券楼层、社群活码楼层、免息券楼层上报埋码
    handleClickFloorProcess(type) {
      let actionCode = '';
      let actionName = '';
      let title = '';
      switch (type) {
        // 3.免息券楼层
        case 'offinterest':
          {
            actionCode = '400060012';
            actionName = '免息券楼层';
            title = '免息券楼层';
          }
          break;
        default:
          console.log('埋码楼层类型不存在！');
      }
      const params = {
        actionCode: actionCode,
        actionName: actionName,
        content: {
          title: title,
          channel: this.loginType == 'none' ? '无需登陆' : this.loginType == 'wechat' ? '微信' : '支付宝',
          activityCode: this.activityCode,
        },
      };
      const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
      if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
        params.content.activityName = eventTrackingData.activityName;
        params.content.activityType = eventTrackingData.activityType;
        params.content.guideUserId = eventTrackingData.guideUserId;
        params.content.channelCode = eventTrackingData.storeCode;
      } else if (this.storeCode && this.guideUserId) {
        params.content.activityName = this.activityName;
        params.content.activityType = this.activityType;
        params.content.guideUserId = this.guideUserId;
        params.content.channelCode = this.storeCode;
      }
      utils.handleBatchReport(this, params);
    },
    // 到领取时间，遮罩关闭可以领取
    timeDownFinished(index) {
      this.item.couponMainVOList[index].useStatus = '01';
    },
    // 返回小程序
    backXcx(item, type) {
      if (this.loginType === 'wechat') {
        // 在微信小程序环境打开
        if ([CouponType.coupon, CouponType.offinterest].includes(type)) {
          // 包含服务商品的优惠券、免息券直接跳选购页
          if (item.serviceGoodFlag === '2' && !item.jumpUrl) {
            wx.miniProgram.reLaunch({
              url: `/pages/tabBar/classify/classify`,
            });
            return;
          }
          if ([SkuScopeType.moreProducts, SkuScopeType.singleProduct].includes(item.skuScopeType) && !item.skuCodeList) {
            if (type === CouponType.offinterest) {
              // 免息券列表跳转
              jumpToNext('', JumpType.interestFreePage, this.loginType, this);
            } else {
              // 优惠券列表跳转
              jumpToNext('', JumpType.couponPage, this.loginType, this);
            }
          } else if (item.jumpUrl) {
            // 如果配置的有活动链接，优先跳转配置的活动链接
            this.goHihonorUrl(item.jumpUrl);
          } else if (item.skuScopeType === SkuScopeType.singleProduct) {
            // 单商品跳详情
            wx.miniProgram.navigateTo({
              url: `/subpackages/index/pages/productDetailsGlobal/product-details-global?skuCode=${item.skuCodeList[0]}&groupCode=${item.groupCode}&thematicActivityCode=${this.activityCode}`,
            });
          } else if (item.skuScopeType === SkuScopeType.moreProducts) {
            // 多商品跳商品聚合页
            wx.miniProgram.navigateTo({
              url: `/subpackages/classify/pages/categories/categories?groupCode=${item.groupCode}&skuScopeType=${item.skuScopeType}&thematicActivityCode=${this.activityCode}`,
            });
          } else {
            // 全部商品跳选购页
            wx.miniProgram.reLaunch({
              url: `/pages/tabBar/classify/classify`,
            });
          }
        }
      } else if (this.loginType == 'Alipay') {
        // 在支付宝小程序环境打开
        if (this.miniprogramFlag) {
          // 包含服务商品的优惠券、免息券直接跳选购页
          if (item.serviceGoodFlag === '2' && !item.jumpUrl) {
            my.reLaunch({
              url: `/pages/tabBar/classify/classify`,
            });
            return;
          }

          // 优惠券、支付宝分期免息券
          if ([CouponType.coupon, CouponType.offinterest].includes(type)) {
            if ([SkuScopeType.moreProducts, SkuScopeType.singleProduct].includes(item.skuScopeType) && !item.skuCodeList) {
              if (type === CouponType.offinterest) {
                // 免息券列表跳转
                jumpToNext('', JumpType.interestFreePage, this.loginType, this);
              } else {
                // 优惠券列表跳转
                jumpToNext('', JumpType.couponPage, this.loginType, this);
              }
            } else if (item.jumpUrl) {
              // 如果配置的有活动链接，优先跳转配置的活动链接
              this.goHihonorUrl(item.jumpUrl);
            } else if (item.skuScopeType === SkuScopeType.singleProduct) {
              // 单商品跳详情
              my.navigateTo({
                url: `/subpackages/index/pages/productDetailsGlobal/product-details-global?skuCode=${item.skuCodeList[0]}&groupCode=${item.groupCode}&thematicActivityCode=${this.activityCode}`,
              });
            } else if (item.skuScopeType === SkuScopeType.moreProducts) {
              // 多商品跳商品聚合页
              my.navigateTo({
                url: `/subpackages/classify/pages/categories/categories?groupCode=${item.groupCode}&skuScopeType=${item.skuScopeType}`,
              });
            } else {
              // 全部商品跳选购页
              my.reLaunch({
                url: `/pages/tabBar/classify/classify`,
              });
            }
          }
        }
      }
    },
    // 领取优惠券/免息券跳转
    goHihonorUrl(url) {
      console.log('goHihonorUrl', url);
      // 链接为积分商城
      if (pointsMallLinkJudge(url) !== PMLinkType.notMatch) {
        jumpToPointsMall(this.activityCode, url);
        return;
      }
      if (this.loginType === 'wechat') {
        // 小程序环境
        if (url.indexOf('pages/webView/activity-web-view?webViewSrc') >= 0) {
          // 1.如果是小程序webview页面，就直接跳转https地址 /pages/webView/activity-web-view?we
          const toUrl = url.split('webViewSrc=')[1];
          window.location.href = toUrl;
        } else if (url.indexOf('http') >= 0) {
          // 2.如果是http地址，就直接跳转
          window.location.href = url;
        } else if (url.indexOf('pages/tabBar/') >= 0) {
          // 3.如果是小程序首页的几个tab页面，用switchTab方法跳转
          wx.miniProgram.switchTab({
            url: url,
          });
        } else if (url.indexOf('subpackages') >= 0) {
          wx.miniProgram.navigateTo({
            url: url,
          });
        }
      } else if (this.loginType === 'Alipay') {
        if (this.miniprogramFlag) {
          // 支付宝小程序环境
          if (url.indexOf('pages/webView/activity-web-view?webViewSrc') >= 0) {
            // 1.如果是小程序webview页面，就直接跳转https地址 /pages/webView/activity-web-view?we
            const toUrl = url.split('webViewSrc=')[1];
            window.location.href = toUrl;
          } else if (url.indexOf('http') >= 0) {
            // 2.如果是http地址，就直接跳转
            window.location.href = url;
          } else if (url.indexOf('pages/tabBar/') >= 0) {
            // 3.如果是小程序首页的几个tab页面，用switchTab方法跳转
            my.switchTab({
              url: url,
            });
          } else if (url.indexOf('subpackages') >= 0) {
            my.navigateTo({
              url: url,
            });
          }
        } else {
          // 支付宝H5环境
          const linkArr = url.split('?');
          let href = '';
          if (linkArr.length > 1) {
            if (linkArr[1].includes('skuCode') || linkArr[1].includes('spuCode')) {
              if (linkArr[0].includes('product-details-global')) {
                href = `alipays://platformapi/startapp?appId=2021002121684220&page=${linkArr[0]}&query=${encodeURIComponent(linkArr[1])}`;
              } else {
                href = `alipays://platformapi/startapp?appId=2021002121684220&page=${linkArr[0]}?${encodeURIComponent(linkArr[1])}`;
              }
            } else {
              href = `alipays://platformapi/startapp?appId=2021002121684220&page=${linkArr[0]}?${encodeURIComponent(linkArr[1])}`;
            }
          } else {
            href = `alipays://platformapi/startapp?appId=2021002121684220&page=${url}`;
          }
          window.location.href = href;
        }
      }
    },
  },
};
</script>


<style scoped lang="scss">
.coupons {
  width: 100%;
  padding: 5px 4% 10px;
  overflow: hidden;
  .coupons_title {
    font-size: 21px;
    color: #1c1c1c;
    font-weight: 700;
    padding: 0 0 15px 0;
  }

  .coupon_card1 {
    position: relative;
    .coupon-corner {
      z-index: 1;
      position: absolute;
      top: 0;
      left: 0;
      height: 4vw;
      width: 10.9vw;
      .coupon-corner-img {
        width: 100%;
        height: 100%;
      }
    }
    .coupon_item {
      border-radius: 12px;
      position: relative;
      background: #ffffff;
      border-radius: 5px;
      margin-top: 8px;
      overflow: hidden;
      height: 26.67vw;
      display: flex;
      align-items: center;
      position: relative;
      .item_content {
        display: flex;
        width: 100%;
        .price-contain {
          width: 20.7vw;
          height: 20.7vw;
          margin-left: 2.3vw;
          margin-right: 1.6vw;
          .main-img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }
        }
        .count_down {
          height: 33.333vw;
          width: 100%;
          border-radius: 5px;
          background-color: rgba(0, 0, 0, 0.4);
          position: absolute;
          top: 0px;
          left: 0%;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 2;
        }
        .balance_count {
          text-align: end;
          font-size: 14px;
        }
        .item_subattr {
          flex-grow: 1;
          max-width: 62.8vw;
          padding-top: 5px;
          .amount_text {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            min-width: 26.7%;
            padding: 25px 10px 10px;
            position: relative;
            .offinterest_img {
              width: 72px !important;
            }
            .coupon_top,
            .coupon_bottom {
              position: absolute;
              right: -5px;
              width: 10px;
              height: 10px;
              border-radius: 50%;
            }
            .coupon_top {
              top: -5px;
            }
            .coupon_bottom {
              bottom: -5px;
            }
          }

          .title_text {
            flex: 1;
            align-self: center;
            margin-left: 8px;
            .title {
              font-size: 14px;
              color: #000000;
              word-break: break-all;
              font-family: HONORSansBrand-Medium;
              line-height: 17px;
              font-weight: 500;
            }
            .use_date {
              font-family: HONORSansBrand-Regular;
              color: #999999;
              font-size: 11px;
              line-height: 13px;
            }
          }
          .opt_btn {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .user-vip {
              margin-right: 6px;
              font-size: 12px;
              color: #848484;
              line-height: 13px;
              font-weight: 400;
            }
            .get-btn {
              width: 68px;
              height: 24px;
              .get-btn-img {
                width: 100%;
                height: 100%;
              }
            }
            .get-btn-position {
              position: relative;
            }
            .get-btn-not {
              width: 68px;
              height: 24px;
              .get-btn-img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .has-received {
          position: absolute;
          top: 0;
          right: 0px;
          width: 16.4vw;
          height: 16.4vw;
          .has-received-img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }
        }
      }
    }
  }

  .coupons_list12 {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-start;
    .coupons_list12_item {
      width: 48.6%;
      background: #ffffff;
      margin-bottom: 10px;
      border-radius: 5px;
      overflow: hidden;
      position: relative;

      .coupons_list12_item_type {
        position: absolute;
        top: 0;
        left: 0;
        display: inline-block;
        background-image: linear-gradient(270deg, #ffffff 0%, #fff3e1 100%);
        border-radius: 0 0 12px 0;
        padding: 3px 6px 3px 3px;
        font-size: 12px;
        color: #b27d13;
        text-shadow: 0 2px 4px rgba(255, 234, 213, 0.86);
      }
      .coupons_list12_item_content {
        text-align: center;
        padding: 30px 0 20px;
        .coupons_list12_item_head {
          position: relative;
          padding: 0 0 10px;
          .coupons_list12_item_content_amount {
            font-size: 32px;
            color: #e2721a;
            line-height: 1;
          }
          .coupons_list12_item_content_text {
            font-size: 12px;
            color: #999999;
          }
          .coupon_left,
          .coupon_right {
            position: absolute;
            bottom: -5px;
            width: 10px;
            height: 10px;
            border-radius: 50%;
          }
          .coupon_left {
            left: -5px;
          }
          .coupon_right {
            right: -5px;
          }
          &::after {
            content: '';
            position: absolute;
            bottom: -0.5px;
            left: 5px;
            right: 5px;
            display: block;
            border-bottom: 1px dashed #e5e5e5;
          }
        }
        .coupons_list12_item_content_name {
          font-size: 14px;
          color: #000000;
          font-weight: 400;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          text-overflow: ellipsis;
          word-break: break-all;
          padding: 10px 12px 0;
        }
        .van-button {
          margin: 10px auto 0;
        }
        .coupons_list12_item_content_countdown {
          padding-top: 5px;
          margin-bottom: -5px;
        }
      }
    }
  }
  .card1_btn {
    align-self: flex-end;
    min-width: 74px;
    height: 28px;
    background: #c79f60;
    border-radius: 15px;
    font-size: 14px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    white-space: nowrap;
    border: none;
    &.goUse {
      background: #b6b6b6;
    }
    &.hasBeenUsed {
      background: #d0d0d0;
      pointer-events: none;
    }
    .card1_btn_text {
      display: flex;
      align-items: center;
      .van-icon {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #c79f60;
        font-size: 10px;
        margin-left: 5px;
      }
    }
  }
  .coupon_mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #00000070;
    .coupon_mask_btn {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .get-btn {
        width: 21.333vw;
        height: 6.4vw;
        .get-btn-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
// 因为如果底部出现了预约xx按钮 按钮的高度和bottom 的和为60 因此 如果又配置了 商品之类的 底部要撑上去60  防止按钮遮挡 商品
.sumOfReservationGuideBtn_height_Bottom {
  padding-bottom: 60px;
}
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; /* 保证不换行 */
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/themaicComponent/offinterest-coupon.vue